import axios, {Method} from 'axios';
import {UNAUTHORIZED} from 'http-status-codes';

export enum Methods {
    DELETE = 'DELETE',
    GET = 'GET',
    PATCH = 'PATCH',
    POST = 'POST',
    PUT = 'PUT',
}

const callAPI = async (url: string, method: Method = Methods.GET, data?: any): Promise<any> => {
    try {
        if (method === Methods.GET && data) {
            return await axios.request({
                url,
                method,
                params: data,
            });
        }

        return await axios.request({
            url,
            method,
            data,
        });
    } catch (error) {
        if (error.status === UNAUTHORIZED) {
            return {
                data: {
                    data: {},
                    errors: [error],
                },
                status: error.status,
            };
        }
        throw error;
    }
};

export default callAPI;
